export default {
  OnBlur: {
    mounted() {
      this.isDestroyed = false;
      this.initialize();
    },

    updated() {
      this.initialize();
    },

    destroyed() {
      this.isDestroyed = true;
    },

    initialize() {
      this.inputName = this.el.dataset.inputName;
      this.eventTarget = this.el.dataset.eventTarget;
      this.onBlurEvent = this.el.dataset.onBlurEvent;

      if (this.el.dataset.inputChanged == 'true') {
        this.dispatchBlurEvent();
      }
    },

    dispatchBlurEvent() {
      const rootElement = this.el;
      const eventTarget = this.eventTarget;
      const inputName = this.inputName;
      const onBlurEvent = this.onBlurEvent;

      // NOTE: This is to ensure that all other internal callbacks are executed before this event
      setTimeout(() => {
        if (this.isDestroyed || !rootElement.isConnected) return;

        if (onBlurEvent)
          if (eventTarget) this.pushEventTo(eventTarget, onBlurEvent, { name: inputName });
          else this.pushEventTo(rootElement, onBlurEvent, { name: inputName });
      }, 50);
    },
  },
};
